import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-project-subscription-management-settings__badges",
  "data-qa": "project-badges"
}
const _hoisted_3 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu" }
const _hoisted_4 = { class: "gfu-project-subscription-management-settings__title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_option_field = _resolveComponent("option-field")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-project-subscription-management-settings _mt-4",
    "data-qa": `projectID:${$props.projectID}`
  }, [
    ($options.hasBadges)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.badges, ({ key, theme, text, dataQa }) => {
            return (_openBlock(), _createBlock(_component_base_badge, {
              key: key,
              theme: theme,
              "data-qa": dataQa
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.SubscriptionManagement.ProjectNotificationsSubsectionHeader), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.projectName), 1 /* TEXT */)
    ]),
    _createVNode(_component_option_field, {
      modelValue: _ctx.model.projectLifecycleNotificationType,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = $event => ((_ctx.model.projectLifecycleNotificationType) = $event)),
        $options.onProjectLifecycleNotificationPreferenceChange
      ],
      "show-placeholder": false,
      "first-column-width": 8,
      options: $options.generalNotificationPreferenceOptions,
      "display-name": _ctx.Resources.SubscriptionManagement.GeneralProjectNotificationsFieldLabel,
      name: "model.projectLifecycleNotificationType",
      layout: "columns",
      class: "_mt-0",
      description: _ctx.Resources.SubscriptionManagement.GeneralProjectNotificationsFieldDescription,
      "data-qa": "project-notifications:General"
    }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
    _createVNode(_component_option_field, {
      modelValue: _ctx.model.projectUpdatesNotificationType,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = $event => ((_ctx.model.projectUpdatesNotificationType) = $event)),
        $options.onProjectUpdatesNotificationPreferenceChange
      ],
      "show-placeholder": false,
      "first-column-width": 8,
      options: $options.notificationPreferenceOptions,
      "display-name": _ctx.Resources.SubscriptionManagement.UpdatesProjectNotificationsFieldLabel,
      name: "model.projectUpdatesNotificationType",
      layout: "columns",
      class: "_mt-2",
      description: _ctx.Resources.SubscriptionManagement.UpdatesProjectNotificationsFieldDescription,
      "data-qa": "project-notifications:Updates"
    }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
  ], 8 /* PROPS */, _hoisted_1))
}